"use client";

import React from "react";
import { Provider } from "react-redux";
import store from ".";
export default function ReduxProvider({
  children
}) {
  return <Provider store={store} data-sentry-element="Provider" data-sentry-component="ReduxProvider" data-sentry-source-file="ReduxProvider.jsx">{children}</Provider>;
}